'use strict';

function getUrlSlug(value) {
  return value
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

function getCategoryIdFromSlug({ I18n, categoryData, categorySlug }) {
  const { id: result } =
    categoryData.find(({ id }) => {
      const name = I18n.t(`modules.category.Name.${id}`);
      return getUrlSlug(name) === categorySlug;
    }) || {};

  return result;
}

function getUrl(base, params) {
  let url = base;

  if (params && params.length) {
    url += `?${params.join('&')}`;
  }

  return url;
}

function getCategoryLink({ categoryName, routes }) {
  const categorySlug = getUrlSlug(categoryName);
  return {
    href: routes.category.show.replace('{categorySlug}', categorySlug),
    'data-bhc': `category:${categorySlug}`,
  };
}

function getCurrentThemedPageSlug(themes) {
  if (!themes) {
    return null;
  }

  const now = Date.now();
  const theme = themes.filter(
    ({ startDate, endDate }) =>
      new Date(startDate) < now && new Date(endDate) > now
  );

  return theme[0] ? { slug: theme[0].slug, title: theme[0].title } : null;
}

module.exports = {
  getUrlSlug,
  getCategoryIdFromSlug,
  getUrl,
  getCategoryLink,
  getCurrentThemedPageSlug,
};
